export default "__VITE_ASSET__FrQPJE6i__"